{
  "name": "@ipreo/demo-app",
  "version": "21.2.4",
  "author": "Polaris Team",
  "license": "UNLICENSED",
  "peerDependencies": {
    "@angular/common": "21.x",
    "@angular/core": "21.x",
    "@angular/router": "21.x",
    "@ngrx/store": "21.x",
    "rxjs": "7.x"
  },
  "dependencies": {
    "tslib": "2.x"
  },
  "nmp": {
    "externalDependencies": {},
    "jsBundle": "./bundles-nmp/demo-app.min.js",
    "jsBundleType": "umd",
    "private": false,
    "platforms": {
      "angular": {
        "moduleName": "DemoAppModule"
      }
    }
  }
}